<template>
    <div class="password-input" >
        <input
        :class="{input: true, visible, error}" :value="value"
        @input="$emit('input', $event.target.value)"
        :type="visible ? 'text' : 'password'"
        @blur="$emit('blur', $event)"
        @focus="$emit('focus', $event)"
        />
        <span class="visible-icon"
        :class="{active: visible}"
        v-if="showVisible"
        @click="changeVisible(!visible)"
        >
            <svg-icon v-if="!visible" href="#codelab-icon-visible-hide" :width="20" :height="20"></svg-icon>
            <svg-icon v-else href="#codelab-icon-visible" :width="20" :height="20"></svg-icon>
        </span>
    </div>
</template>
<script>
export default {
    name: 'password-input',
    props: {
        value: String,
        showVisible: Boolean,
        error: Boolean
    },
    data () {
        return {
            visible: false
        }
    },
    created () {
        this._value = this.value || ''
    },
    methods: {
        changeVisible (visible) {
            this.visible = visible
        }
    }
}
</script>
<style lang="scss">
.password-input{
    display: inline-block;
    width: 100%;
    height: 50px;
    overflow: hidden;
    position: relative;
    font-size: 0;
    line-height: 0%;
    .input{
        width: 100%;
        height: 50px;
        line-height: 48px;
        border: 1px solid #a8a8ac;
        background: transparent;
        border-radius: 8px;
        outline: none;
        font-size: 42px;
        color: #ffffff;
        overflow: hidden;
        padding: 0 32px 0 16px;
        &:focus{
            color: #0ed3ff;
        }
        &.error{
            border-color: #fd5c53;
        }
        &.visible{
            font-size: 18px;
            letter-spacing: 0.12em;
        }
    }
    .visible-icon{
        position: absolute;
        display: inline-block;
        width: 20px;
        height: 20px;
        font-size: 0;
        line-height: 0;
        right: 12px;
        top: 50%;
        margin-top: -10px;
        cursor: pointer;
        .svg-icon{
            fill: #b4b4b4;
        }
        &.active{
            .svg-icon{
                fill: #0ed3ff;
            }
        }
    }
}
</style>
